import React from "react";
import PropTypes from "prop-types";
import { ToCurrency } from "../../../utils";
import { PRICINGOVERVIEW } from "npmlinks-constants";
import { GridRow, GridColumn } from "arv-reactcomponents";

function TotalPayable({ total }) {
  return (
    <GridRow className="nw-totalpayable-row">
      <GridColumn className="nwc-grid-col-xs-8 nwc-grid-col-sm-5 nw-totalpayable-col">
        <i className="icomoon-payable-amount nw-totalpayable-icon" />
        <span className="nw-totalpayable-text">
          {PRICINGOVERVIEW.TOTAL_PAYABLE}
        </span>
      </GridColumn>
      <GridColumn className="nwc-grid-col-xs-4 nwc-grid-col-sm-7 nw-totalpayable-valuecol">
        <span className="nw-totalpayable-valuespan">
          {ToCurrency(total || 0)}
        </span>
      </GridColumn>
    </GridRow>
  );
}

TotalPayable.propTypes = {
  total: PropTypes.number.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: TotalPayable.wrappedComponent,
  component: TotalPayable,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/PaymentComponent/TotalPayable/index.js